import {
  formatTime,
  query as utilQuery,
  replaceParams,
  lstore,
  sstore,
  storeCheck,
  throttle,
  debounce,
  cookie,
} from '@tencent/eyao-util-core';

function query(name, url) {
  return utilQuery(name, url || window.location.href);
}

export { formatTime, query, replaceParams, lstore, sstore, storeCheck, throttle, debounce, cookie };
